import React from "react";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  light?: boolean;
}

const IconButton = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, loading, light, ...props }, ref) => {
    return (
      <button
        ref={ref}
        {...props}
        className={`btn-primary btn-circle btn capitalize ${
          light ? "border-none bg-light hover:bg-light" : ""
        } ${className} ${loading ? "loading" : ""}`}
      >
        {loading ? null : props.children}
      </button>
    );
  },
);

IconButton.displayName = "IconButton";

export default IconButton;
